// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U23L","type":"styles_type__2zSxq","choices":"styles_choices__12P24"};